import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import IconModal from "shared/components/IconModal";
import _str from "shared/util/_str";
import Str from "shared/components/Str";
import BoostTokenIcon from "shared/components/svgs/boost_token.svg";
import sourceFromPathname from "analytics/util/source";
import Analytics from "analytics/util/Analytics";
import BoostBoltIcon from "../../icons/BoostBolt.svg";

import "./FinishedBoostModal.scss";

const onClick = () => {
	const boostModelLastPromoId = get(window.BoostController, "Model.data.lastpromoid");

	if (boostModelLastPromoId) {
		window.BoostController.closeReport();
	}

	window.BoostController.open("boostagain");
};

const Footer = ({ onClose }) => {
	return (
		<button
			className="finished-boost-modal-button"
			onClick={() => {
				onClick();
				onClose();
			}}

		>
			<BoostBoltIcon className="finished-boost-modal-button-icon" /> <Str>Boost Again</Str>
		</button>
	);
};

Footer.propTypes = {
	onClose: PropTypes.func.isRequired,
};

const FinishedBoostModal = ({ onClose, show, viewMultiplier }) => {
	const cachedViewMultiplier = useRef();

	useEffect(() => {
		if (show) {
			Analytics.logUIEvent(
				Analytics.eventNames.viewedFirstPartyPromo,
				{
					data: {
						"promo id": "boost.boostagain",
						"came from": "boost.boostagain",
						source: sourceFromPathname(),
						"is upsell": true,
					},
				},
			);
		}

		if (viewMultiplier !== null) {
			cachedViewMultiplier.current = viewMultiplier;
		}
	}, [show, viewMultiplier]);

	return (
		<IconModal
			onClose={onClose}
			show={show}
			image={<BoostTokenIcon height={67} width={61} className="finished-boost-modal-icon" />}
			headerText={_str("Your Boost worked!")}
			bodyText={_str(`You just increased your profile views  ${cachedViewMultiplier.current}x.  Nice work.  👌`)}
			footerChildren={<Footer onClose={onClose} />}
		/>
	);
};

FinishedBoostModal.propTypes = {
	onClose: PropTypes.func.isRequired,
	show: PropTypes.bool,
	viewMultiplier: PropTypes.number,
};

FinishedBoostModal.defaultProps = {
	show: false,
	viewMultiplier: 1.1,
};

export default FinishedBoostModal;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/BoostButton/FinishedBoostModal/FinishedBoostModal.jsx